import { render, staticRenderFns } from "./NovakidPrivacyContent.vue?vue&type=template&id=33bd1dfc"
import script from "./NovakidPrivacyContent.vue?vue&type=script&lang=js"
export * from "./NovakidPrivacyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0_supports-_8222eee745b2e984d0467402f7084607/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports